






import Vue from "vue";
import { fetchItems } from "@/store/actions";

export default Vue.extend({
  name: "App",
  created() {
    this.$store.dispatch(fetchItems());
  }
});
